import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { collection, addDoc, getDocs, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import { saveAs } from "file-saver";

const TopluPersonelYukle = () => {
  const [excelData, setExcelData] = useState([]);
  const [rapor, setRapor] = useState([]);
  const [mevcutTCList, setMevcutTCList] = useState(new Set());

  useEffect(() => {
    const fetchMevcutTC = async () => {
      const snap = await getDocs(collection(db, "personeller"));
      const mevcutSet = new Set(snap.docs.map(doc => doc.data().tc?.toString()));
      setMevcutTCList(mevcutSet);
    };
    fetchMevcutTC();
  }, []);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (evt) => {
      const workbook = XLSX.read(evt.target.result, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      setExcelData(jsonData);
    };
    reader.readAsBinaryString(file);
  };

  const formatDate = (value) => {
    if (!value) return null;
    const date = typeof value === "string" ? new Date(value) : new Date((value - 25569) * 86400 * 1000);
    if (isNaN(date.getTime())) return null;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleUpload = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) return alert("Giriş yapılmamış!");

    const yeniKayitlar = [];
    const tcSetInFile = new Set();
    const hatalar = [];

    for (let i = 0; i < excelData.length; i++) {
      const row = excelData[i];
      const tc = row["T.C. NO"]?.toString().trim();
      const ad = row["AD"]?.toString().trim();
      const soyad = row["SOYAD"]?.toString().trim();
      const gorev = row["GÖREV"]?.toString().trim() || "";
      const tesis = row["TESİSİ"]?.toString().trim() || "";

      const tarih = {};
      let enAzBirGirisVar = false;

      for (let j = 1; j <= 4; j++) {
        const g = formatDate(row[`GİRİŞ${j}`]);
        const c = formatDate(row[`ÇIKIŞ${j}`]);
        if (g) {
          tarih[`giris${j}`] = g;
          enAzBirGirisVar = true;
        }
        if (c) {
          tarih[`cikis${j}`] = c;
        }
        if (g && c && new Date(c.split("-").reverse().join("-")) < new Date(g.split("-").reverse().join("-"))) {
          hatalar.push({ Satır: i + 2, TC: tc, Hata: `ÇIKIŞ${j}, GİRİŞ${j}'den önce olamaz` });
          continue;
        }
      }

      if (!ad || !soyad || !tc || !enAzBirGirisVar) {
        hatalar.push({ Satır: i + 2, TC: tc, Hata: "Eksik temel bilgi (ad, soyad, tc, giris1)" });
        continue;
      }

      if (tcSetInFile.has(tc)) {
        hatalar.push({ Satır: i + 2, TC: tc, Hata: "Aynı dosyada tekrar ediyor" });
        continue;
      }

      if (mevcutTCList.has(tc)) {
        hatalar.push({ Satır: i + 2, TC: tc, Hata: "Bu TC sistemde kayıtlı" });
        continue;
      }

      tcSetInFile.add(tc);
      yeniKayitlar.push({ ad, soyad, tc, gorev, tesis, tarih, createdBy: currentUser.email, createdAt: serverTimestamp() });
    }

    for (const k of yeniKayitlar) {
      await addDoc(collection(db, "personeller"), k).catch(() => {
        hatalar.push({ Satır: "-", TC: k.tc, Hata: "Veri kaydedilemedi" });
      });
    }

    setRapor(hatalar);
    alert(`${yeniKayitlar.length} kayıt yüklendi, ${hatalar.length} hata oluştu.`);
  };

  const handleTemplateDownload = () => {
    const ws = XLSX.utils.json_to_sheet([
      {
        AD: "Ali",
        SOYAD: "Yılmaz",
        "T.C. NO": "12345678901",
        GÖREV: "Operatör",
        TESİSİ: "Sincan",
        GİRİŞ1: new Date(),
        ÇIKIŞ1: "",
        GİRİŞ2: "",
        ÇIKIŞ2: "",
        GİRİŞ3: "",
        ÇIKIŞ3: "",
        GİRİŞ4: "",
        ÇIKIŞ4: "",
      },
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Personeller");
    const file = XLSX.write(wb, { type: "binary", bookType: "xlsx" });
    const buf = new ArrayBuffer(file.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < file.length; ++i) view[i] = file.charCodeAt(i) & 0xff;
    const blob = new Blob([buf], { type: "application/octet-stream" });
    saveAs(blob, "personel_excel_sablonu.xlsx");
  };

  return (
    <div style={{ padding: 30 }}>
      <h2>Excel'den Toplu Personel Yükle</h2>
      <button onClick={handleTemplateDownload}>Örnek Şablonu İndir</button>
      <br /><br />
      <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
      <br /><br />
      <button onClick={handleUpload} disabled={excelData.length === 0}>Aktar</button>

      {excelData.length > 0 && (
        <>
          <h3>📄 Yükleme Önizlemesi</h3>
          <table border="1" cellPadding={4}>
            <thead>
              <tr>
                <th>AD</th>
                <th>SOYAD</th>
                <th>TC</th>
                <th>GİRİŞ/ÇIKIŞ</th>
              </tr>
            </thead>
            <tbody>
              {excelData.map((row, idx) => {
                const tarihStr = [1,2,3,4].map(i => {
                  const g = formatDate(row[`GİRİŞ${i}`]);
                  const c = formatDate(row[`ÇIKIŞ${i}`]);
                  return (g || c) ? `GİRİŞ${i}: ${g || "-"} / ÇIKIŞ${i}: ${c || "-"}` : null;
                }).filter(Boolean).join(" | ");
                return (
                  <tr key={idx}>
                    <td>{row["AD"]}</td>
                    <td>{row["SOYAD"]}</td>
                    <td>{row["T.C. NO"]}</td>
                    <td>{tarihStr}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}

      {rapor.length > 0 && (
        <>
          <h3>🚫 Hatalı Kayıtlar</h3>
          <table border="1" cellPadding={5}>
            <thead>
              <tr>
                <th>Satır</th>
                <th>TC</th>
                <th>Hata</th>
              </tr>
            </thead>
            <tbody>
              {rapor.map((r, i) => (
                <tr key={i}>
                  <td>{r.Satır}</td>
                  <td>{r.TC}</td>
                  <td>{r.Hata}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default TopluPersonelYukle;
